import React from 'react';
import ExtendSearchBase from './ExtendSearchBase';
import { Checkbox } from '../../Controls';
import { SALE, LANDS, REALTY_TYPES } from '../../../consts';
import { getAgencies } from '../../../utils/dictionaries';

class SaleLands extends ExtendSearchBase {
  constructor (props) {
    super(props);
    this.displayName = 'saleLands';
    const dic = props.dictionary;

    this.usageCategoryItems = dic.getUsageCategoryItems(SALE, LANDS);
    this.materialTypeItems = dic.getMaterialTypeItems(SALE, LANDS);
    this.renovationTypeItems = dic.getRenovationTypeItems(SALE, LANDS);
    this.heatingTypeItems = dic.getHeatingTypeItems(SALE, LANDS);
    this.applicationItems = dic.getApplicationItems(SALE, LANDS);
    this.agenciesList = getAgencies(props.agenciesList, this.displayName);
  }

  getObjectTypeId () {
    return this.props.filter.get('objectTypeId', '') || '';
  }

  isLand () {
    return this.getObjectTypeId().split(',').indexOf('' + REALTY_TYPES.land) !== -1;
  }

  isHouse () {
    const ids = this.getObjectTypeId().split(',').filter(Boolean);
    if (ids.length === 1 && this.isLand()) {
      return false;
    }

    return !!ids.length;
  }

  renderPanel () {
    return (<div>
  {
    (this.isHouse() || !this.getObjectTypeId()) && (
      <div className='filter-section__container'>
        <h3 className='title'>Параметры дома</h3>

        <div className='container__row'>
          <div className='container__column'>
            {this.renderInputGroup('Общая площадь, м²', null, [
              {name: 'squareTotalMin', placeholder: 'От', handler: this.getHandlerFloat('squareTotalMin', 7)},
              {name: 'squareTotalMax', placeholder: 'До', handler: this.getHandlerFloat('squareTotalMax', 7)}
            ])}
            {this.renderInputGroup('Жилая площадь, м²', null, [
              {name: 'squareLivingMin', placeholder: 'От', handler: this.getHandlerFloat('squareLivingMin', 7)},
              {name: 'squareLivingMax', placeholder: 'До', handler: this.getHandlerFloat('squareLivingMax', 7)}
            ])}
            {this.renderInputGroup('Площадь кухни, м²', null, [
              {name: 'squareKitchenMin', placeholder: 'От', handler: this.getHandlerFloat('squareKitchenMin', 7)},
              {name: 'squareKitchenMax', placeholder: 'До', handler: this.getHandlerFloat('squareKitchenMax', 7)}
            ])}
          </div>
          <div className='container__column'>
            {this.renderMultiSelect('Материал дома', 'materialId', this.materialTypeItems, true)}
            {this.renderMultiSelect('Состояние / ремонт', 'renovationTypeId', this.renovationTypeItems, true)}
            {this.renderMultiSelect('Вид отопления', 'heatingId', this.heatingTypeItems, true)}
          </div>
          <div className='container__column'>
            {this.renderInputGroup('Дом не ниже, этажей', null, [
              {name: 'floorTotalMin', placeholder: 'Количество этажей', handler: this.getHandlerInt('floorTotalMin', 7)}
            ])}
          </div>
        </div>
      </div>
    )
  }

          <div className='filter-section__container'>
            <h3 className='title'>Параметры участка</h3>

            <div className='container__row'>
              <div className='container__column'>
                {this.renderInputGroup('Площадь участка, соток', null, [
                  {name: 'squareLandMin', placeholder: 'От', handler: this.getHandlerFloat('squareLandMin', 7)},
                  {name: 'squareLandMax', placeholder: 'До', handler: this.getHandlerFloat('squareLandMax', 7)}
                ])}
                {this.renderInputGroup('Удаленность от города, км', null, [
                  {name: 'distanceFromCityMin', placeholder: 'От', handler: this.getHandlerFloat('distanceFromCityMin', 7)},
                  {name: 'distanceFromCityMax', placeholder: 'До', handler: this.getHandlerFloat('distanceFromCityMax', 7)}
                ])}
              </div>
              <div className='container__column'>
                {this.isLand() && this.renderMultiSelect('Категория использования', 'usageCategoryId', this.usageCategoryItems, true)}
                {this.renderControlGroup('Коммуникации', (
                  <div>
                    <Checkbox
                      label='канализация'
                      checked={this.getFilter('hasCanalization')}
                      onUpdate={(_, state) => this.setFilter('hasCanalization', state ? 1 : null)}
                    />
                    <Checkbox
                      label='водоснабжение'
                      checked={this.getFilter('hasWater')}
                      onUpdate={(_, state) => this.setFilter('hasWater', state ? 1 : null)}
                    />
                    <Checkbox
                      label='электричество'
                      checked={this.getFilter('hasElectricity')}
                      onUpdate={(_, state) => this.setFilter('hasElectricity', state ? 1 : null)}
                    />
                    <Checkbox
                      label='газ'
                      checked={this.getFilter('hasGas')}
                      onUpdate={(_, state) => this.setFilter('hasGas', state ? 1 : null)}
                    />
                  </div>
                ))}
              </div>
              <div className='container__column'>
                {this.renderControlGroup('Инфраструктура', (
                  <div>
                    <Checkbox
                      label='охрана'
                      checked={this.getFilter('hasSecurityProtection')}
                      onUpdate={(_, state) => this.setFilter('hasSecurityProtection', state ? 1 : null)}
                    />
                    <Checkbox
                      label='гараж'
                      checked={this.getFilter('hasGarage')}
                      onUpdate={(_, state) => this.setFilter('hasGarage', state ? 1 : null)}
                    />
                    <Checkbox
                      label='баня'
                      checked={this.getFilter('hasBathhouse')}
                      onUpdate={(_, state) => this.setFilter('hasBathhouse', state ? 1 : null)}
                    />
                    <Checkbox
                      label='хоз. постройки'
                      checked={this.getFilter('hasOutbuildings')}
                      onUpdate={(_, state) => this.setFilter('hasOutbuildings', state ? 1 : null)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

      <div className='filter-section__container'>
        <h3 className='title'>Прочие параметры</h3>

          <div className='container__row'>
            <div className='container__column'>
              {this.getUserIsAdmin() && this.renderMultiSelect('Приложения', 'sourceAppId', this.applicationItems, true)}
              {this.renderMultiSelect('Агентство / застройщик', 'agencyId', this.agenciesList, true, 'Неважно', true)}
            </div>
            <div className='container__column'>
              {this.renderInputGroup('Поиск в описании', null, [
                {name: 'description', placeholder: 'Ключевые слова', handler: this.getHandlerString('description')}
              ])}
              {this.renderInputGroup('Контактный телефон', null, [
                {name: 'contactPhone', placeholder: '123 456 78 90', handler: this.getHandlerInt('contactPhone')}
              ])}
            </div>
            <div className='container__column'>
              {this.renderInputGroup('Номер объявления', null, [
                {name: 'id', placeholder: '12345678', handler: this.getHandlerInt('id')}
              ])}

              {this.renderControlGroup('Дополнительно', (
                <div>
                  <Checkbox
                    label='Частные объявления'
                    checked={this.getFilter('onlyOwners')}
                    onUpdate={(_, state) => this.setFilter('onlyOwners', state ? 1 : null)}
                  />
                  <Checkbox
                    label='С фото'
                    checked={this.getFilter('hasPhoto')}
                    onUpdate={(_, state) => this.setFilter('hasPhoto', state ? 1 : null)}
                  />
                  {this.hasMls() && <Checkbox
                    label='МЛС'
                    checked={this.getBool('isMls')}
                    onUpdate={(_, state) => this.handlerMls(_, state)}
                  />}
                </div>
              ))}
            </div>
          </div>
      </div>
    </div>);
  }
}

export default SaleLands;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/SaleLands.jsx